import Success from "components/Success";

export default Success;
